export default __webpack_public_path__ + "static/media/Lato-Bold.76eff648.ttf";